import * as echarts from 'echarts'
import {useEffect, useRef} from 'react'
import useWindowSize from '../../utils/useWindowSize'
const LatestTrendChart = ({summary, dataPoint}) => {
    const chartRef = useRef(null)
    const windowSize = useWindowSize()

    useEffect(() => {
        const chartDom = document.getElementById(summary.key)
        if (!chartDom || !dataPoint) {
            return echarts.dispose(chartDom)
        }

        let dataSeries = [...dataPoint]

        if (dataSeries?.length < 7) {
            const remaining = 7 - dataSeries?.length

            for (let i = 0; i < remaining; i++) {
                dataSeries.unshift(0)
            }
        }

        const myChart = echarts.init(chartDom)

        const option = {
            grid: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                containLabel: false,
            },
            xAxis: {
                show: false,
                type: 'category',
                boundaryGap: false,
            },
            yAxis: {
                show: false,
                type: 'value',
                min: 0,
                boundaryGap: [0, 0],
            },
            series: [
                {
                    type: 'line',
                    smooth: true,
                    data: dataSeries,
                    areaStyle: {color: summary.chartColor},
                    lineStyle: {
                        width: 2,
                        color: summary.chartColor,
                    },
                    // symbol: 'none',
                },
            ],
        }

        myChart.setOption(option)

        return () => {
            myChart.dispose()
        }
    }, [dataPoint, summary, windowSize])

    return (
        <div
            id={summary.key}
            ref={chartRef}
            className="flex h-10rem p-0 w-full"
            style={{width: '100%'}}></div>
    )
}

export default LatestTrendChart
